// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		loadProductFirst: false,
	}
};

// Declare Templates
var bcSfFilterTemplate = {
	// Grid Template
	'productGridItemHtml': '<div class="grid__item grid-product {{itemGridItemWidthClass}} {{itemQuickShopClass}} {{itemHoverDetailClass}}" data-aos data-product-grid data-id="{{itemId}}" data-boost-theme-quickview="{{itemId}}">' +
								'<div class="grid-product__content">' + 
									'{{itemLabels}}' +
									'<a {{itemHref}} class="grid-product__link {{itemSoldOutClass}} {{itemQuickShopBtnClass}}" data-product-id="{{itemId}}" data-url="{{itemUrl}}">' +
										'<div class="product-slider" data-image-count="{{itemImageCount}}" data-id="{{itemId}}">' +
											'{{itemImages}}' +
										'</div>' +
										'{{itemImageStyle}}' +
										'<div class="grid-product__meta">' +
											'<div class="grid-product__title">{{itemTitle}}</div>' +
											'{{itemVendor}}' +
											'<div class="grid-product__price">{{itemPrice}}</div>' +
											'{{itemReviews}}' +
										'</div>' +
										'{{itemSwatches}}' +
									'</a>' +
								'</div>' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></a></span>',
	'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">…</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by">{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
	var soldOut = !data.available; 
	var onSale = data.compare_at_price_min > data.price_min;
	var priceVaries = data.price_min != data.price_max;
	var images = data.images_info;
	
	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;
	
	// Add classes
	itemHtml = itemHtml.replace(/{{itemGridItemWidthClass}}/g, bcSfFilterConfig.custom.grid_item_width);
	itemHtml = itemHtml.replace(/{{itemHoverDetailClass}}/g, bcSfFilterConfig.custom.product_hover_details ? 'grid-product__hover-details' : '');
	itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, soldOut ? 'grid-product__link--disabled' : '');
	itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, bcSfFilterConfig.custom.quick_shop_enable && data.available ? 'grid-product__has-quick-shop' : '');
	itemHtml = itemHtml.replace(/{{itemQuickShopBtnClass}}/g, bcSfFilterConfig.custom.quick_shop_enable ? 'quick-product__btn js-screen-open-product-{{itemId}} js-no-transition' : '');
	itemHtml = itemHtml.replace(/{{itemHref}}/g, bcSfFilterConfig.custom.quick_shop_enable ? '' : 'href={{itemUrl}}');

	// Add labels
	var itemLabelsHtml = buildLabels(data, onSale, soldOut);
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

	// Add images
	var itemImagesHtml = buildImages(data);
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
	itemHtml = itemHtml.replace(/{{itemImageCount}}/g, images.length == 0 ? 1 : images.length);

	var itemImageStyle = '';
	if (images.length > 1){
		var loaderDuration = 1350 * images.length;
		itemImageStyle = '<style>' +
							'.product-slider.slick-initialized[data-id="{{itemId}}"]:after {' +
								'animation-duration: ' + loaderDuration + 'ms;' +
							'}' +
						'</style>';
	}
	itemHtml = itemHtml.replace(/{{itemImageStyle}}/g, itemImageStyle);

	// Add vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? '<div class="grid-product__vendor">'+ data.vendor +'</div>' : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add price
	var itemPriceHtml = buildPrice(data, onSale, priceVaries);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add reviews
	var itemReviewsHtml = bcSfFilterConfig.custom.enable_product_reviews_collection ? '<div data-bv-show="inline_rating" data-bv-product-id="{{itemId}}" data-bv-redirect-url="{{itemUrl}}" data-bv-seo="false"></div>	' : '';
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add swatches
	var itemSwatchesHtml = buildSwatches(data);
	itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	return itemHtml;
};

function buildLabels(data, onSale, soldOut){
	var html = '';
	var customLabel = '';
	if (data.tags){
		for (var i = 0; i < data.tags.length; i++){
			if (data.tags[i].indexOf('_label_') == 0){
				customLabel = data.tags[i].replace('_label_', '');
			}
		}
	}
	if (customLabel){
		html = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
	} else if (soldOut) {
		html = '<div class="grid-product__tag grid-product__tag--sold-out">' + bcSfFilterConfig.label.sold_out + '</div>';  
	} else if (onSale){
		var saleText = '';
		if (bcSfFilterConfig.custom.product_save_amount){
			var savedAmount = '';
			if (bcSfFilterConfig.custom.product_save_type == 'dollar'){
				savedAmount = bcsffilter.formatMoney(data.compare_at_price_min - data.price_min);
			} else {
				savedAmount = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min) + '%';
			}
			saleText = bcSfFilterConfig.label.save_html.replace(/{{ saved_amount }}/g, savedAmount);
		} else {
			saleText = bcSfFilterConfig.label.sale;
		}
		html = '<div class="grid-product__tag grid-product__tag--sale">' + saleText + '</div>';
	}
	return html;
}

function buildImages(data){
	var html = '';
	var images = data.images_info;
	if (!images || images.length == 0){
		images.push({
			src: bcSfFilterMainConfig.general.no_image_url,
			width: 480,
			height: 480,
			id: 0
		})
	}
	var imageLimit = bcSfFilterConfig.custom.product_hover_image ? 10 : 1;
	images.forEach(function(image, index){
		if (index >= imageLimit) return;
		var imageHtml = '';
		var aspectRatio = image.width / image.height;
		var imagePadding = 100 / aspectRatio;		
		if (index == 0){
			if (bcSfFilterConfig.custom.product_grid_image_size != "natural"){
				imageHtml = '<div class="grid__image-ratio grid__image-ratio--'+ bcSfFilterConfig.custom.product_grid_image_size +' lazyload"'+
							' data-bgset="' + bgset(image) + '"' +
							' data-sizes="auto">' +
							'</div>';
			} else {				
				imageHtml = '<div class="image-wrap" style="height: 0; padding-bottom: '+ imagePadding +'%;">'+
							'<img class="grid-product__image lazyload"' +
							' data-src="'+ bcsffilter.optimizeImage(image.src, '{width}x') +'"' +
							' data-widths="[750, 900, 1080]"' +
							' data-aspectratio="'+ aspectRatio +'"' +
							' data-sizes="auto"' +
							' alt="{{itemTitle}}">' +
							'</div>';
			}
		} else {
			var imagePaddingStyle = bcSfFilterConfig.custom.product_grid_image_size == "natural" ? ('style="padding-bottom: ' + imagePadding + '%"') : '';
			imageHtml = '<div class="grid__image-ratio grid__image-ratio--'+ bcSfFilterConfig.custom.product_grid_image_size +' lazyload" ' +
						imagePaddingStyle +
						' data-bgset="' + bgset(image) + '"' +
						' data-sizes="auto">' +
		  				'</div>';
		}
		html += '<div class="product-slide">'+
					'<div class="image-wrap">'+ imageHtml +'</div>' +
				'</div>';
		
	})
	return html;
}

function buildPrice(data, onSale, priceVaries){
	var html = '';
	if (onSale){
		html += '<span class="visually-hidden">'+ bcSfFilterConfig.label.regular_price +'</span>';
		html += '<del class="grid-product__price--original"><span class="money">'+ bcsffilter.formatMoney(data.compare_at_price_min) +'</span></del>';
		html += '<span class="visually-hidden">'+ bcSfFilterConfig.label.sale_price +'</span>';
	}
	if (priceVaries){
		html += '<span class="money">' + bcSfFilterConfig.label.from_text.replace(/{{ price }}/g, bcsffilter.formatMoney(data.price_min)) + '</span>';
	} else {
		html += '<span class="money">' + bcsffilter.formatMoney(data.price_min) + '</span>';
	}
	return html;
}

function buildSwatches(data){
	var html = '';
	var values = [];
	var swatchItems = [];
	if (bcSfFilterConfig.custom.collection_color_swatches){
		data.variants.forEach(function(variant){
			var colorValue = '';
			variant.merged_options.forEach(function(option){
				var key = option.split(':')[0].toLowerCase();
				var value = option.split(':')[1];
				if ((key.indexOf('color') != -1 || key.indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1){
					values.push(value.toLowerCase());
					colorValue = value;
				}
			});
			if (colorValue){
				var colorImage = bcSfFilterMainConfig.general.asset_url.split('bc-sf-filter.js')[0] + bcsffilter.slugify(colorValue) + '_50x.png';
				var colorBackground = bcsffilter.slugify(colorValue).split('-').pop();
				var swatchItem = '<span class="color-swatch color-swatch--small" ' +
									'style="background-image: url('+ colorImage +');' +
									' background-color: '+ colorBackground +';">' +
								  '</span>';
				swatchItems.push(swatchItem);				  	  
			}
		})
	}
	if (swatchItems.length > 0){
		html = '<div class="grid-product__colors">' + swatchItems.join(' ') + '</div>';
	}
	return html;
}

function bgset(image) {
	var bgset = '';
	if (image) {
		var aspect_ratio = image.width / image.height;

		if (image.width > 180) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
		if (image.width > 360) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
		if (image.width > 540) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
		if (image.width > 720) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
		if (image.width > 900) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
		if (image.width > 1080) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
		if (image.width > 1296) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
		if (image.width > 1512) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
		if (image.width > 1728) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
		if (image.width > 1950) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
		if (image.width > 2100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
		if (image.width > 2260) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
		if (image.width > 2450) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
		if (image.width > 2700) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
		if (image.width > 3000) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
		if (image.width > 3350) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
		if (image.width > 3750) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
		if (image.width > 4100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
		bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
	}
	return bgset;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}
	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	// Add quick view modal
	if (bcSfFilterConfig.custom.quick_shop_enable){
		this.buildExtrasProductListByAjax(data, 'bc-sf-quickview', function(results){
			results.forEach(function(result){
				if (jQ('#ProductScreen-'+ result.id).length == 0){
				  	jQ('[data-boost-theme-quickview="'+ result.id +'"]').append(result.quickview);							
				}
			});
			buildTheme(true);
		});
	}
	buildTheme();
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {};

function buildTheme(isBuildQuickShopEvent){
	if (window.sections && window.theme){				
		if (bcSfFilterConfig.custom.quick_shop_enable && isBuildQuickShopEvent){
			// move quickshop from product item to #ProductScreens
			theme.QuickShopScreens.init();

			// init product inside quick view modal
			sections.register('product-template', theme.Product, jQ('#ProductScreens'));

			// open quick view
			jQ('.quick-product__btn').each(function(){
				jQ(this).on('click', function(){
					var productId = jQ(this).data('product-id');
					jQ('#ProductScreen-' + productId).addClass('screen-layer--is-active');
					jQ('html').addClass('screen-layer-open');
					jQ('body').addClass('screen-layer-open');
					$('body').trigger('productModalOpen.ProductScreen-' + productId);
				})
			});

			// close quick view
			jQ('.js-screen-close').each(function(){
				jQ(this).on('click', function(){
					var productId = jQ(this).closest('.screen-layer--product').data('product-id');
					jQ(this).closest('.screen-layer--product').removeClass('screen-layer--is-active');
					jQ('html').removeClass('screen-layer-open');
					jQ('body').removeClass('screen-layer-open');
					$('body').trigger('productModalClose.ProductScreen-' + productId);
				})
			});
		}

		// Hover image slideshow
		sections.register('collection-template', theme.Collection);

		// AOS reveal image, init shopify review, multi currency
		theme.reinitProductGridItem(); 
	}
}

BCSfFilter.prototype.setDefaultParams = function(params) {
  var self = this;
  params.shop = params.hasOwnProperty('shop') ? params.shop : this.shopDomain;
  params.page = params.hasOwnProperty('page') ? parseInt(params.page) : 1;  

  // Products per page
  var settingLimit = this.getSettingValue('general.limit');
  if (this.getSettingValue('general.paginationType') == 'default' || this.getSettingValue('general.paginationTypeAdvanced')) {
    params.limit = params.hasOwnProperty('limit') ? params.limit : settingLimit;
  } else {
    params.limit = (params.hasOwnProperty('limit') ? params.limit : settingLimit) * params.page;
  }
  // Sorting
  if (this.isSearchPage()) this.defaultSorting = 'price-descending';
  params.sort = params.hasOwnProperty('sort') ? params.sort : this.defaultSorting;
  // Display type
  params.display = params.hasOwnProperty('display') ? params.display : this.getSettingValue('general.defaultDisplay');

  /**
   * Prepare the params for the third-party app
   */
  params = self.setThirdPartyAppParams(params);

  return params;
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
